import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import './ClearPopup.module.scss';
import customIsoString from 'utilities/custom-iso-string';

/**
 * Import actions
 */
import clearForever from 'actions/event/clearForever';
import clearPeriod from 'actions/event/clearPeriod';

/**
 * Import FontAwesome
 */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const mapStateToProps = (state, props) => {
    return {

    };
};

const mapDispatchToProps = {
    clearForever,
    clearPeriod
};


class ClearPopup extends Component {

    constructor() {
        super();

        this.handleClear = this.handleClear.bind(this);

    }

    handleClear() {
        let startDate = customIsoString(this.props.clearDate, true);
        let data = {};
        let tempDate = this.props.clearDate;
        let currentDay = this.props.clearDate.getDay();
        let endDate =  customIsoString(tempDate.setDate(tempDate.getDate() + (7-currentDay)), true);
        if (this.props.type == 'all') {
            data = {
                start: startDate
            };
            this.props.clearForever(data).then(() => {
                this.props.onClose();
            });
        }
        else if (this.props.type == 'week') {
            let startOfTheWeek = new Date(endDate);
            startOfTheWeek =  customIsoString(startOfTheWeek.setDate(startOfTheWeek.getDate() -6), true);
            data = {
                start: startOfTheWeek,
                end: endDate
            };
            this.props.clearPeriod(data).then(() => {
                this.props.onClose();
            });
        } else if (this.props.type == 'dag') {
            data = {
                start: startDate,
                end: startDate
            };
            this.props.clearPeriod(data).then(() => {
                this.props.onClose();
            });
        }
    }

    render() {

        return (
            <div styleName='move-wrapper'>
                {this.props.type === 'all' && <p style={{ fontWeight: '800' }}>Je bent van plan vanaf hier alles leeg te maken.</p>}
                {this.props.type !== 'all' && <p style={{ fontWeight: '800' }}>Je bent van plan deze {this.props.type ? `${this.props.type}` : ''} leeg te maken.</p>}

                {this.props.type === 'all' && <p>Weet je zeker dat je vanaf hier alles leeg wil maken? Let op, je gekoppelde huiswerk wordt ook verwijderd. Agenda items blijven behouden</p>}
                {this.props.type !== 'all' && <p>Weet je zeker dat je deze {this.props.type ? `${this.props.type}` : ''} leeg wil maken? Let op, je gekoppelde huiswerk wordt ook verwijderd. Agenda items blijven behouden</p>}

                <div styleName='bottom-text'>
                    <p onClick={this.props.onClose}>Annuleer</p>
                    <p styleName='red' onClick={this.handleClear}>Ok</p>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ClearPopup);
